export enum dataHooks {
  progressIndicator = 'progress-indicator',
  label = 'label',
  successIcon = 'success-icon',
  errorIcon = 'error-icon',
  progressArcForeground = 'progressarc-foreground',
  progressArcBackground = 'progressarc-background',
}
